export class SqlQueryExecutionResult {
    'queryExecutionId';
    'columns';
    'rows';
    'nextToken';
    'totalRowCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "queryExecutionId",
            "baseName": "queryExecutionId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<SqlQueryExecutionResultColumn>",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<Array<any>>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalRowCount",
            "baseName": "totalRowCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlQueryExecutionResult.attributeTypeMap;
    }
    constructor() {
    }
}
